<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from '../../../../../services/i18n';
	import { gen2Request } from '../../../../../services/gen_2_http_reqs';
	//Stores
	//Helpers
	import { isProCover, real_id } from '../../../../../helpers/interface_helpers';
	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	const inputOptions = ['button', 'switch'];
	const _input_options_i18n = [$format('working_type_button'), $format('working_type_switch')];

	let settings = readDeviceSettings(id),
		inputTypes = {},
		inputs_counter = (Number(device.channel) || 0) === 0 ? 0 : 2,
		loading = false,
		cache;

	onMount(() => {
		// Object.keys(settings).forEach(channel => {
		// if (channel.includes('input')) {
		// 	type[inputs_counter] = settings[`input:${inputs_counter}`].type;
		// 	++inputs_counter;
		// }
		// });
		inputTypes[inputs_counter] = settings[`input:${inputs_counter}`].type;
		if (isProCover(device.type)) {
			// Pro 2 Cover G2 and G4 check
			inputTypes[inputs_counter + 1] = settings[`input:${inputs_counter + 1}`].type;
		}
		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		// for (let input = 0; input < inputs_counter; input++) {
		inputTypes[inputs_counter] = value;
		if (isDualCover(device.type)) {
			// Pro 2 Cover G2 and G4 check
			inputTypes[inputs_counter + 1] = value;
		}
		// }
	};

	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			let isok = false;
			loading = true;
			for (let input in inputTypes) {
				let params = { id: input, config: { type: inputTypes[input] } };

				const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', params);

				if (res.isok) {
					settings[`input:${input}`].type = inputTypes[input];
					isok = true;
					cache[input] = inputTypes[input];
				} else {
					toast.open({
						type: 'danger',
						title: $format('input_type_err_toast') || 'Error! Could not change input mode.',
					});
					isok = false;
					inputTypes[input] = cache[input];
				}
				loading = false;
			}
			if (isok)
				toast.open({
					type: 'success',
					title: $format('input_type_scc_toast', {
						values: { mode_value: inputTypes[inputs_counter] },
					}),
				});
		}
	};
</script>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('input_type_desc', { default: 'Set input type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={option}
		value={inputTypes[inputs_counter]}
		on:click={() => setInputType(option)}
		id="radio-o3foy84"
	>
		{_input_options_i18n[index]}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
